import { Select, SelectProps } from "antd";
import React from "react";

const CustomSelect: React.FC<SelectProps> = ({ ...props }) => {
  return <Select popupClassName="cus-select-wrap" {...props} />;
};

export default CustomSelect;
